module.exports = [{"Team":"South Dakota","Coach":"Todd Lee","Shot Quality After Timeout":1.25,"Occurrences":78,"Rank of all coaches (353)":"1st"}]